export default {
  /**
   * Hôm nay
   */
  Today: 0,

  /**
   *Trước đó
   */
  Before: 1,
};
